export type ColorType = string

export const MAX_SCREEN_WIDTH = 1640

export interface CyberOwlTheme {
    colors: {
        text: {
            default: ColorType
            deemphasize: ColorType
            error: ColorType
            warning: ColorType
            whiteText: ColorType
        }
        background: {
            selectedLocationPage: ColorType
            selectedPage: ColorType
            page: ColorType
            default: ColorType
            lowContrast: ColorType
            whiteBackground: ColorType
        }
        boxShadow: {
            highContrast: ColorType
        }
        link: {
            primary: ColorType
            disabled: ColorType
        }
        border: {
            lowContrast: ColorType
        }
        newIndicator: {
            text: ColorType
            flash: ColorType
            background: ColorType
        }
    }
    login: {
        error: {
            errorBorder: ColorType
            errorBackground: ColorType
            errorContent: ColorType
        }
        success: {
            loginBorder: ColorType
            loginBackground: ColorType
            loginContent: ColorType
            actionsFooter: ColorType
        }
    }
    loadingPage: {
        background: ColorType
    }

    navigationResponsive: {
        dataArea: {
            background: ColorType
            miniBackground: ColorType
            locationExpandedArea: ColorType
            miniTextColor: ColorType
            textColor: ColorType
        }
        active: {
            background: ColorType
            underLine: ColorType
        }
    }

    reports: {
        dataArea: {
            background: ColorType
            boxShadow: ColorType
            borderLeft: ColorType
        }
        resetButton: {
            text: ColorType
            background: ColorType
        }
        narrowButton: {
            default: {
                backgroundColor: ColorType
                textColor: ColorType
            }
            hover: {
                backgroundColor: ColorType
                textColor: ColorType
            }
        }
        dataRow: {
            text: ColorType
            background: ColorType
            separator: ColorType
        }
        starRating: {
            selected: {
                fill: ColorType
                background: ColorType
            }
            unSelected: {
                fill: ColorType
                background: ColorType
            }
            hover: {
                fill: ColorType
                background: ColorType
            }
            staticIcon: {
                selected: ColorType
                unSelected: ColorType
            }
        }
        actionButton: {
            text: ColorType
            background: ColorType
            border: ColorType
        }
        filterBar: {
            boxShadow: ColorType
            closeButton: {
                text: ColorType
                background: ColorType
                border: ColorType
            }
        }
    }
    pagingButton: {
        clickable: {
            default: {
                background: ColorType
                text: ColorType
                border: ColorType
            }
            hover: {
                background: ColorType
                text: ColorType
                border: ColorType
            }
            active: {
                background: ColorType
                text: ColorType
                border: ColorType
            }
        }
        selected: {
            background: ColorType
            text: ColorType
        }
        disabled: {
            background: ColorType
            text: ColorType
            border: ColorType
        }
    }
    refreshButton: {
        default: {
            borderColor: ColorType
            backgroundColor: ColorType
            textColor: ColorType
        }
        hover: {
            borderColor: ColorType
            backgroundColor: ColorType
            textColor: ColorType
        }
        active: {
            borderColor: ColorType
            backgroundColor: ColorType
            textColor: ColorType
        }
        disabled: {
            borderColor: ColorType
            backgroundColor: ColorType
            textColor: ColorType
        }
    }

    font: {
        family: string
        weight: {
            light: number
            normal: number
            semibold: number
            bold: number
            extrabold: number
        }
    }
}
